<template>
  <div id="header">
    <div :class="$mq ==='mobile' ? 'wrapper' : ''">
      <div :class="$mq ==='mobile' ? 'line' : ''">

        <div class="languages" :class="[header,{TA:isTestAchat}]">
          <div class="inline space-between" :class="{border:!isTestAchat}">
            <a v-if="!isTestAchat" class="phone" :href="`tel:${$t('phoneHref')}`"><SvgIcon icon="phone" class="icon" fill></SvgIcon> {{ $t('phone') }}</a>
            <span class="language" @click="switchLocale()">{{ locale }}</span>
          </div>
        </div>

        <div
          class="nav inline space-between"
          :class="$mq !== 'mobile' ? 'container-header left' : 'mobile space-between'"
        >
          <a :href="getMegaUrl" target="_blank">
            <img src="@/assets/logoMegaHeader.svg" />
          </a>

          <div v-if="isTestAchat" class="partner inline" :class="$mq">
            <!-- <img :src="partner" v-if="partner" /> -->
            <h3 style="max-width: 160px; color: #231F20">{{ $t('branding.special_offer') }}</h3>
            <a :href="getPartnerUrl" target="_blank" id="partner-logo"><img :src="require(`@/assets/logos/${getPartnerLogo}`)" v-if="isTestAchat" id="partner-logo-img"/></a>
          </div>
        </div>
      </div>
      <!-- <div class="notification" v-if="notification && $i18n.locale === 'nl' && campaign !== 'WATZ'">
        <p>
          Ben je klant van de Vlaamse Energieleverancier? Dankzij Mega blijft jouw energielevering gegarandeerd. <a href="https://become.mega.be/nl">Stap gemakkelijk (online) over naar Mega</a>, kies ons "VEL" product en behoud je oude variabele voorwaarden en profiteer van een aantrekkelijke korting! Wij voorzien je vanaf 7/12 van onze energie (met terugwerkende kracht en overname van je meterstanden), zonder enig risico van onderbreking.
        </p>
        <div class="close" @click="notification=false"></div>
      </div> -->
    </div>

    <!-- <div class="banner" v-if="$mq !== 'mobile'">
      <div :class="$mq !== 'mobile' ? 'container' : ''">
        <h1 v-html="$t('title')"></h1>
      </div>
    </div>

    <div class="subtitle" :class="$mq !== 'mobile' ? 'container' : ''" v-if="$mq !== 'mobile' && !noSubscribe">
      <h2>{{ $t(`subtitles.${subtitle}.title`) }}</h2>
      <p>{{ $t(`subtitles.${subtitle}.text`, [this.$store.state.comparison.economyText]) }}</p>
    </div> -->
  </div>
</template>

<script>
import { mapGetters, mapState } from "vuex";
import partnerService from "@/services/partnerService";
import moment from "moment";

export default {
  data() {
    return {
      mobileMenu: false,
      partner: null,
      notification: true
    };
  },
  computed: {
    ...mapState("common", ["lang", "agentRef"]),
    ...mapGetters("common", ["isTestAchat"]),
    subtitle() {
      let subtitle = "estimation";

      if (this.$route.name === "Simulation") subtitle = "simulation";
      if (this.$route.name === "Comparison") subtitle = "comparison";

      return subtitle;
    },
    locale() {
      return this.$i18n.locale === "fr" ? "NL" : "FR";
    },
    noSubscribe() {
      return this.$router.currentRoute.query.noSubscribe !== undefined || this.$store.state.common.noSubscribe;
    },
    campaign() {
      return this.$route.query.campaign || this.$store.state.common.campaign;
    },
    header(){
      return this.$mq !== 'mobile' ? 'container-header' : '';
    },
    getPartnerLogo() {
      const lang = this.locale === 'NL' ? 'fr' : 'nl';
      return 'testachats_logo_'+lang+'.png';
    },
    getPartnerUrl() {
      return this.locale === 'NL' ? 'https://www.test-achats.be/energyguide/mes-achats-energie/action-speciale' : 'https://www.test-aankoop.be/energyguide/mijn-energie-aankopen/speciale-actie'; //TODO change to get it dynamically from back-end
    },
    getMegaUrl() {
      return this.locale === 'NL' ? 'https://www.mega.be/fr' : 'https://www.mega.be/nl';
    }
  },
  methods: {
    async partnerBranding() {
      // if (this.agentRef && !this.partner) {
      //   let response = await partnerService.getPartner(this.agentRef);

      //   if (
      //     response.valid &&
      //     moment(response.valid_from) <= moment() &&
      //     moment(response.valid_to) >= moment()
      //   ) {
      //     this.partner = `${process.env.FILE_STORE}/${response.file}`;
      //   }
      // }
    },

    switchLocale() {
      if (this.$i18n.locale === "fr") {
        this.$i18n.locale = "nl";
        this.$store.commit("common/setLang", "nl");
        if(this.$route.query.lang !== undefined) this.$route.query.lang = "nl";
      } else {
        this.$i18n.locale = "fr";
        this.$store.commit("common/setLang", "fr");
        if(this.$route.query.lang !== undefined) this.$route.query.lang = "fr";
      }

      this.$store.dispatch("contact/getCivilities", this.$i18n.locale);
    }
  },
  created() {
    this.partnerBranding();
  }
};
</script>

<style lang="scss">
@import "https://cdn.jsdelivr.net/npm/animate.css@3.5.1";
.languages {
  color: $grey;
  background: $white;



  .border {
    min-height: 40px;
    padding-top: 1px;
    padding-bottom: 2px;
    margin: 0 13px;
    border-bottom: 2px solid $lightGrey;
  }

  .phone {
    text-decoration: none;
    color: $black;
    display: flex;
    font-size: 0.85rem;
    font-weight: 600;
    padding: 12px 15px;

    .icon {
      margin-right: 5px;
      color: $black;
    }
  }

  .language {
    cursor: pointer;
    font-size: 0.91rem;
    font-weight: 400;
    padding: 12px 15px;
    transition: all 0.3s;

    &:hover {
      background: #fdcb47;
      color: #59666f;
    }
  }

  &.TA {
    background-color: $orange!important;
    color: $white;


    div {
      justify-content: end;

      .language {
        &:hover {
          background-color: $white;
          color: $black;
        }
      }
    }
  }
}

.nav {
  // margin: 0 13%;
  position: relative;
  background: white;

  img {
    padding: 17px 14px;
    max-height: 56px;
    height: 56px;

    &.partner {
      height: 40px;
    }
  }

  &.mobile {

    > * {
      padding: 10px;
      // width: 50%;
      flex: 1;
      // margin: 17px 14px;

      img {
        width: 100%;
        padding: 0;
      }
    }

  }
}

.banner {
  min-height: 215px;
  color: #231f20;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: flex-start;
  background: url("../assets/header_check2.png") repeat-x bottom, #fcc648;

  h1 {
    margin: 15px;
    width: 100%;
    text-align: left;
    font-size: 3.4rem;
    font-weight: 600;
  }

  h2 {
    margin: 0;
    font-size: 1.9rem;
  }
}
.wrapper {
  // height: 120px;
  background: white;
  position: relative;

  .fixed {
    position: fixed;
    z-index: 99;
    top: 0;
    left: 0;
    right: 0;
    background: white;
    border-bottom: 1px solid #fcc648;
  }

  .line {
    border-bottom: 1px solid #fcc648;
  }

  .icon-menu {
    margin-right: 10px;
    font-size: 1.8rem;
    color: #fdcb47;
  }

}

.notification {
  background: $clearYellow;
  padding: 10px 50px;
  display: flex;
  align-items: center;

  p {
    text-align: left;
    font-size: 0.75rem;
    margin: 0;
    padding: 0;
  }

  .close {
    cursor: pointer;
    margin-left: 20px;
    min-width: 18px;
    min-height: 18px;
    max-height: 18px;
    height: 18px;
    width: 18px;
    border-radius: 50%;
    background: no-repeat url('~@/assets/icons/icon-close.svg') center center/50% white;
  }
}

.subtitle {
  text-align: left;

  h2 {
    padding: 0;
    margin: 0;
    margin-top: 20px;
    margin-left: 15px;
    font-weight: 600;
    font-size: 1.3rem;
  }

  p {
    font-size: 0.9rem;
    margin: 10px 0;
    margin-left: 15px;
  }
}



.partner {
  #partner-logo {
    height: 100%;
    width: 100%;
    padding:0;
  }

  #partner-logo-img {
    height: 100%;
    width: 100%;
  }

  h3 {
    font-size: 16px;
    font-weight: 700;
    margin:0;
  }

  &.desktop {
    flex-wrap: nowrap;

    h3 {
      font-size: 18px;
      margin-top: 10px;
    }

    #partner-logo {
    margin-left: 20px;
    height: 60%;
    width: 60%;
  }
  }

}
</style>



// WEBPACK FOOTER //
// src/components/Header.vue